import React, { useEffect, useState } from 'react';

export interface StepperProps {
  numSteps?: number;
  step: number;
  labels?: string[];
}

export const Stepper: React.FC<StepperProps> = (props) => {
  const numSteps = props.numSteps ?? 3;
  const [step, setStep] = useState<number>(props.step);

  useEffect(() => {
    setStep(props.step);
  }, [props.step]);

  const getItems = (): React.ReactNode[] => {
    let items: React.ReactNode[] = [];

    for (let i = 0; i < numSteps; i++) {
      const isDone = i < step - 1;
      const isInProgress = i === step - 1;

      items.push(
        <div key={i} className="styled-stepper-step">
          <div
            className={
              'styled-stepper-icon' +
              (isDone ? ' done' : '') +
              (isInProgress ? ' in-progress' : '')
            }
          >
            {i + 1}
          </div>

          <span
            className={
              'styled-stepper-label' +
              (isDone ? ' done' : '') +
              (isInProgress ? ' in-progress' : '')
            }
          >
            {props.labels?.[i] ?? ''}
          </span>
        </div>
      );

      if (i < numSteps - 1)
        items.push(
          <span
            key={'_' + i}
            className={
              'styled-stepper-delim' +
              (isDone ? ' done' : '') +
              (isInProgress ? ' in-progress' : '')
            }
          />
        );
    }

    return items;
  };

  return <div className="styled-stepper">{getItems()}</div>;
};
